import { useEffect, useMemo, useRef, useState } from 'react';

import Session from "./Session";

import moment from "moment";
import ukMoment from "../../../../utils/ukTime";

import styles from "../../../../styles/Calendar.module.scss";

function Day({day, sessions, rowTimes, selectedSessions, toggleSession, user}) {
	const [open, setOpen] = useState(false);

	const selectedForDay = useMemo(() => (
		selectedSessions.filter(s => ukMoment(s.start).format('YYYY-MM-DD') === day).length
	), [selectedSessions, day]);

	const prevSelectedForDay = useRef(0);
	useEffect(() => {
		if (selectedForDay > prevSelectedForDay.current) setOpen(false);
		prevSelectedForDay.current = selectedForDay;
	}, [selectedForDay]);

	const daySessions = useMemo(() => {
		return sessions.filter((session) => {
			return ukMoment(session.start).format('YYYY-MM-DD') === day;
		});
	}, [sessions, day]);

	const sessionsByTime = useMemo(() => {
		return daySessions.reduce((acc, session) => {
			acc[ukMoment(session.start).format('HH:mm')] = session;
			return acc;
		}, {});
	}, [daySessions]);

	return (
		<div className={`${styles.day} ${open ? styles.open : null}`}>
			<div className={styles.heading} onClick={() => { setOpen(!open) }}>
				<img src={require('../../../../images/drop-down.svg').default} alt="" />
				<p><strong>{moment.utc(day).format('ddd')}</strong> {moment.utc(day).format('Do')} {moment.utc(day).format('MMM')}</p>
			</div>

			<div className={styles.times}>
				{rowTimes.map((time) => {
					const session = sessionsByTime[time];

					if(!session) {
						return <div key={`${day}-${time}`} className={`${styles.session} ${styles.empty}`} />;
					}

					return (
						<Session
							key={`${session.start}-${session.end}`}
							session={session}
							selectedSessions={selectedSessions}
							toggleSession={toggleSession}
							user={user}
						/>
					);
				})}
			</div>
		</div>
	)
}

export default Day;
